import { render, staticRenderFns } from "./tandC.vue?vue&type=template&id=4e2c80f6&scoped=true"
import script from "./tandC.vue?vue&type=script&lang=js"
export * from "./tandC.vue?vue&type=script&lang=js"
import style0 from "./tandC.vue?vue&type=style&index=0&id=4e2c80f6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e2c80f6",
  null
  
)

export default component.exports